import { parseMonthKey } from 'common/utils/schoolYearMonths';

export interface FormatAbridgedWeekTitleInput {
  mode?: string | null;
  weekNumber?: number | null;
  monthKey?: string | null;
  schoolYearWeek?: number | null;
}

/** Số nguyên ≥ 1. 0, âm, lẻ thì coi là MenuPlan chưa gửi. */
const usableSchoolYearWeek = (value: number | null | undefined): number | null =>
  typeof value === 'number' && Number.isInteger(value) && value >= 1 ? value : null;

const monthTitle = (
  weekNumber: number | null | undefined,
  monthKey: string | null | undefined
): string | null => {
  if (typeof weekNumber !== 'number' || !Number.isInteger(weekNumber)) return null;
  const parsed = parseMonthKey(monthKey);
  if (!parsed) return null;
  return `TUẦN ${weekNumber} THÁNG ${parsed.month}`;
};

/** Phần tuần của tiêu đề tờ, không gồm tiền tố «THỰC ĐƠN BÁN TRÚ». `null` = giữ weekTitle resource. */
export const formatAbridgedWeekTitle = (input: FormatAbridgedWeekTitleInput): string | null => {
  if (input.mode === 'year') {
    const yearWeek = usableSchoolYearWeek(input.schoolYearWeek);
    if (yearWeek !== null) return `TUẦN ${yearWeek}`;
  }
  return monthTitle(input.weekNumber, input.monthKey);
};
